import { render, staticRenderFns } from "./AppStaffListBlock.vue?vue&type=template&id=b42203e6&scoped=true"
import script from "./AppStaffListBlock.vue?vue&type=script&lang=js"
export * from "./AppStaffListBlock.vue?vue&type=script&lang=js"
import style0 from "./AppStaffListBlock.vue?vue&type=style&index=0&id=b42203e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42203e6",
  null
  
)

export default component.exports